import { forwardRef } from 'react';
import {
  Container,
  Header,
  HeaderText,
  CloseIcon,
  Copy,
  TooltipContainer,
  TooltipBody,
  Arrow,
} from 'components/ToolkitV2/Tooltip/Tooltip.styled';

import { POSITION } from 'components/ToolkitV2/Tooltip/Tooltip.typed';
import type { TooltipProps } from 'components/ToolkitV2/Tooltip/Tooltip.typed';

import { accessibleOnClick } from 'utils/Accessibility';

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  const {
    isOpen,
    children,
    headerText,
    headerFontSize = 'M16',
    headerFontWeight = 'bold',
    copy,
    askToClose,
    position = POSITION.ABOVE,
    className,
    dataTrackingAttribute,
  } = props;

  return (
    <Container className={className} ref={ref}>
      {isOpen && (
        <TooltipContainer
          position={position}
          data-tracking={dataTrackingAttribute}
        >
          <TooltipBody>
            <Header>
              <HeaderText
                fontSize={headerFontSize}
                fontWeight={headerFontWeight}
              >
                {headerText}
              </HeaderText>

              {askToClose && (
                <CloseIcon
                  {...accessibleOnClick(
                    askToClose,
                    'button',
                    0,
                    'close-button',
                  )}
                  height={16}
                  width={16}
                />
              )}
            </Header>

            {copy && <Copy>{copy} </Copy>}
            <Arrow position={position} />
          </TooltipBody>
        </TooltipContainer>
      )}
      {children}
    </Container>
  );
});

Tooltip.displayName = 'Tooltip';

export { Tooltip };
